import styled from 'styled-components';

import { ReactComponent as FileSVG } from '../../assets/icons/file-color.svg';
import { Button, Typography } from '../../designComponents';

const EndlessPossibilitiesStyled = styled.div`
  padding: 60px 30px;
  background-color: ${({ theme }) => theme.colors.blueShadow};
  & .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1030px;
    margin: 0 auto;
    & .file-icon {
      height: 166px;
      margin-bottom: 30px;
    }
    & .heading {
      font-size: 32px;
      line-height: 40px;
      font-weight: 600;
      margin-bottom: 30px;
      color: ${({ theme }) => theme.colors.darkText};
      text-align: center;
    }
    & .desc {
      font-size: 20px;
      line-height: 32px;
      font-weight: 500;
      margin-bottom: 30px;
      color: ${({ theme }) => theme.colors.secondaryText};
      text-align: center;
    }

    & .browse-btn {
      border-radius: 25px;
      padding: 10px 16px;
    }
  }

  @media (max-width: 500px) {
    & .container {
      & .file-icon {
        height: 110px;
      }
      & .heading {
        font-size: 20px;
        line-height: 32px;
      }
      & .desc {
        font-size: 14px;
      }
    }
  }
`;

const EndlessPossibilities = () => {
  return (
    <EndlessPossibilitiesStyled>
      <div className="container">
        <FileSVG className="file-icon" />
        <Typography className="heading">
          Unlock Endless Possibilities with Our Extensive Library of Templates
          and Symbols!
        </Typography>
        <Typography className="desc">
          Explore a world of design possibilities with our extensive collection
          of templates and symbols. Whether for fire escape plans, floor
          layouts, or building schematics, our platform has the tools you need.
          Discover and unleash your creativity today!
        </Typography>
        <Button className="browse-btn">Browse Now</Button>
      </div>
    </EndlessPossibilitiesStyled>
  );
};

export default EndlessPossibilities;
